import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { SnHeader } from "@shared/components/SnHeader";
import { global } from "@shared/libs/Global";
import { menuInfo } from "@shared/type/CommonType";
import SearchPanel, { ValueChangedEvent } from "@widgets/SearchPanel";
import { getInitFormData } from "@shared/utils/CommonUtils";
import PrdCalendar, {
  PrdCalendarRef,
} from "./SN_PRD_BAS_REP_013_Calendar";

interface Props {
  Menuprops: menuInfo;
}

const pad = (value: number) => String(value).padStart(2, "0");
const toYm = (value?: string) => String(value ?? "").replace(/[^0-9]/g, "").slice(0, 6);

const SN_PRD_BAS_REP_013 = forwardRef(({ Menuprops }: Props, ref) => {
  const today = new Date();
  const userInfo: any = global.getState().userInfo;
  const defaultYm = String(today.getFullYear()) + pad(today.getMonth() + 1);
  const searchPanelRef = useRef<any>(null);
  const calenderRef = useRef<PrdCalendarRef>(null);
  const [searchData, setSearchData] = useState<any>({ ym: defaultYm });
  const [searchControlData, setSearchControlData] = useState<any[]>([]);
  // 달력생성 버튼(sys_headerctrl grid1). getInitFormData가 이미 {controls,data}로 준다(재감싸기 금지).
  const [headerInfo, setHeaderInfo] = useState<any>({ controls: [], data: {} });

  const onSearch = async () => {
    await calenderRef.current?.onSearch();
  };

  const onCreateCalendar = async () => {
    await calenderRef.current?.onCreateCalendar();
  };

  const onSearchValueChanged = (event: ValueChangedEvent) => {
    if (event.colId !== "ym") return;
    const ym = toYm(event.newValue);
    if (ym.length !== 6) return;
    setSearchData({ ...event.rowData, ym });
  };

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        const ym = toYm(rtn.formData?.ym) || defaultYm;
        setSearchControlData(rtn.formControlData);
        setHeaderInfo(rtn.header?.grid1 ?? { controls: [], data: {} });
        setSearchData({
          ...rtn.formData,
          ym,
          cd_module: Menuprops.cd_module,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({ onSearch }));

  return (
    <div className="h-full flex flex-col bg-[#f4f5f7] text-[13px]">
      <div className="border-b border-gray-300 bg-white">
        <SearchPanel
          ref={searchPanelRef}
          data={searchData}
          controls={searchControlData}
          onValueChanged={onSearchValueChanged}
        />
        <div className="flex justify-end px-4 pt-2 pb-1">
          <SnHeader
            headerInfo={headerInfo}
            onButtonClick={(sender: string) => {
              if (sender === "btnCreate") onCreateCalendar();
            }}
          />
        </div>
      </div>

      <PrdCalendar
        ref={calenderRef}
        queryId="sn_prd_bas_rep_013_01"
        saveEndPoint="SN_PRD_BAS_REP_013_SAVE_01"
        ym={searchData.ym}
        cdFirm={userInfo.cd_firm}
      />
    </div>
  );
});

export default SN_PRD_BAS_REP_013;
